import React from "react";
import { python, tensorflow, pytorch, scikit } from "../../assets";

import "./skills.css";

const AI = () => {
  return (
    <div>
      <h1 className="tech__heading">AI / ML</h1>
      <div className="tech__section">
        <div>
          <img src={python} alt="python" className="tech__logo" />
          <p>Python</p>
        </div>

        <div>
          <img src={scikit} alt="scikit" className="tech__logo" />
          <p>Scikit-learn</p>
        </div>

        <div>
          <img src={tensorflow} alt="tensorflow" className="tech__logo" />
          <p>Tensorflow</p>
        </div>

        <div>
          <img src={pytorch} alt="pytorch" className="tech__logo" />
          <p>Pytorch</p>
        </div>
        {/*
        <div>
          <img src={ethereum} alt="ethereum" className="tech__logo" />
          <p>Ethereum</p>
        </div> */}

        {/* <div>
          <img src={hardhat} alt="hardhat" className="tech__logo" />
          <p>Hardhat</p>
        </div>

        <div>
          <img src={ethers} alt="ethers" className="tech__logo" />
          <p>Etherjs</p>
        </div> */}

        {/* <div>
          <img src={polygon} alt="polygon" className="tech__logo" />
          <p>Polygon</p>
        </div>
        <div>
          <img src={solidity} alt="solidity" className="tech__logo" />
          <p>Solidity</p>
        </div> */}

        {/* <div>
          <img src={openzeppelin} alt="openzeppelin" className="tech__logo" />
          <p>OpenZeppelin</p>
        </div> */}

        {/* <div>
          <img src={chainlink} alt="chainlink" className="tech__logo" />
          <p>Chainlink</p>
        </div> */}

        {/* <div>
          <img src={metamask} alt="metamask" className="tech__logo" />
          <p>Metamask</p>
        </div> */}

        {/* <div>
          <img src={ipfs} alt="ipfs" className="tech__logo" />
          <p>IPFS</p>
        </div> */}
      </div>
    </div>
  );
};

export default AI;
